import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { IRecommendedProfessionalApi } from './recommendedProfessionalsTypes';

export interface IGetRecommendedProfessionalsParams {
  officeId: string;
  jobId?: string;
  date?: string;
}

async function getRecommendedProfessionals({
  officeId,
  jobId,
  date,
}: IGetRecommendedProfessionalsParams): Promise<IRecommendedProfessionalApi[]> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<{ data: IRecommendedProfessionalApi[] | null }>(
    `/offer-discovery/professionals/recommended`,
    {
      headers: { ...headers, 'x-office': officeId ?? undefined },
      params: {
        jobId: jobId ?? undefined,
        date: date ?? undefined,
      },
    },
  );

  return response?.data?.data ?? [];
}

export const recommendedProfessionalsApi = {
  getRecommendedProfessionals,
};
